import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    textDecoration: 'none',
  },
  thumbnail: {
    background: '#add8e6',
  },
  textBlock: {
    backgroundColor: COLOR.YELLOW,
    color: COLOR.DARK_GREEN,
    textDecoration: 'none',
    width: '90%',
    margin: 'auto',
    padding: [15],
    transform: 'translateY(-26px)',
    [MQ.TABLET]: {
      padding: [22],
      width: '85%',
    },
    [MQ.DESKTOP]: {
      padding: [30],
      width: '78%',
    },
  },
  title: {
    padding: [8, 0],
  },
  category: {
    textTransform: 'uppercase',
  },
  altBlock: {
    backgroundColor: COLOR.OFF_WHITE,
  },
  interviewee: {
    letterSpacing: '0.1em',
  },
})
